import Button from "@/components/Button"
import Dialog from "@/components/Dialog"
import Spinner from "@/components/Spinner"
import Toast from "@/components/Toast"
import { useState } from "react"
import { toast } from "sonner"
import ActionButton from "./ActionButton"
import { useUpdatePrescriptionEnrollmentStatus } from "@/data/queries"
import { CustomerSupportPrescription, getPatientFullName } from "@/model/CustomerSupport"

// TODO: Needs MRN from patient
type ReadyToOrderButtonProps = {
  prescription: CustomerSupportPrescription
}

const ReadyToOrderButton = ({ prescription }: ReadyToOrderButtonProps) => {
  const patient = prescription.patient
  const [isDialogOpen, setIsDialogOpen] = useState(false)
  const { mutateAsync: updatePrescriptionEnrollment, isPending } =
    useUpdatePrescriptionEnrollmentStatus()

  const handleConfirm = async () => {
    await updatePrescriptionEnrollment({
      prescriptionId: prescription.id,
      newStatus: "READY_TO_ORDER_DEVICE",
    })
    setIsDialogOpen(false)
    toast.custom((toastId) => (
      <Toast
        toastId={toastId}
        description="Patient marked as ready to order."
      />
    ))
  }

  return (
    <>
      <ActionButton onClick={() => setIsDialogOpen(true)}>
        Ready to order
      </ActionButton>
      <Dialog
        title="Confirm ready to order"
        isOpen={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        className="max-w-lg"
      >
        <div className="flex flex-col gap-4">
          <p>
            Are you sure you want to mark <strong>{getPatientFullName(patient)}</strong> as
            ready to receive orders?
          </p>
          <div className="flex justify-end gap-3">
            <Button
              variant="neutral"
              onClick={() => setIsDialogOpen(false)}
              disabled={isPending}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={handleConfirm}
              disabled={isPending}
              className="flex items-center gap-2"
            >
              {isPending && <Spinner className="h-4 w-4" />}
              Confirm
            </Button>
          </div>
        </div>
      </Dialog>
    </>
  )
}

export default ReadyToOrderButton
